import Indicator from './includes/Indicator'

function Navigation(props: NavigationProps) {
  const { currentSlide, totalImages, onClick } = props

  const isFirst = currentSlide + 1 <= 1
  const isLast = currentSlide + 1 >= totalImages

  return (
    <>
      {!isFirst && (
        <Indicator
          currentSlide={currentSlide}
          direction="left"
          onClick={onClick}
        />
      )}
      {!isLast && (
        <Indicator
          currentSlide={currentSlide}
          direction="right"
          onClick={onClick}
        />
      )}
    </>
  )
}

interface NavigationProps {
  currentSlide: number
  totalImages: number
  onClick(index: number): void
}

export default Navigation
